import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import { Card, FormControl, Grid, Icon, InputLabel, MenuItem, Modal, Select } from "@mui/material";
import MDTypography from "../../components/MDTypography";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { deleteReservationNoteBook, getReservationNoteBook, updateReservationNoteBookStatus } from "../../api/routes";
import { useState } from "react";
import { useEffect } from "react";
import queryString from "../../components/queryString";
import Loading from "../../components/Loading";
import { useReactToPrint } from "react-to-print";
import MDButton from "../../components/MDButton";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "jalali-moment";
import MDInput from "../../components/MDInput";
import useModal from "../../hooks/useModal";
import UpdateReservationNoteBookModal from "./UpdateReservationNoteBookModal";
import ReservationNoteBookHistoryModal from "./ReservationNoteBookHistoryModal";
import useMe from "../../hooks/useMe";
import MDBadge from "../../components/MDBadge";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
export default function ReservationNoteBookList() {
  const [page, setPage] = useState(0);
  const [customerPrintInfo, setCustomerPrintInfo] = useState([]);
  const [totalRow, setTotalRow] = useState(25);
  const [modals, updateModal, closeModal] = useModal({ noteBook: { state: false }, noteBookHistory: { state: false } });
  const [me] = useMe();

  const columns = [
      {
        field: "reservationDate",
        headerName: "تاریخ نوبت",
        width: 160,
        valueGetter: (params) => `${params.row.subTime} - ${String(params.row.reservationDate).slice(0, 4)}/${String(params.row.reservationDate).slice(4, 6)}/${String(params.row.reservationDate).slice(6)}`,
      },
      {
        field: "fullname",
        headerName: "نام و نام خانوادگی",
        width: 200,
      },
      {
        field: "nameGroup",
        headerName: "تخصص نوبت",
        width: 200,
        valueGetter: (params) => `${params.row.nameGroup} - ${params.row.subNameGroup}`,
      },
      {
        field: "phoneNumber",
        headerName: "تلفن همراه",
        width: 120,
      },
      {
        field: "description",
        headerName: "توضیحات",
        width: 120,
      },
      {
        field: "adminUsername",
        headerName: "کاربر ثبت کننده",
        width: 120,
      },
      {
        field: "createdAt",
        headerName: "تاریخ ایجاد",
        width: 200,
        valueGetter: (params) => new Date(params.row.createdAt).toLocaleString("fa-IR"),
      },
      {
        field: "operation",
        headerName: "عملیات",
        width: 250,
        renderCell: (params) =>
          <section style={{ display: "flex", cursor: "pointer", alignItems: "center" }}>
            <Icon style={{ marginLeft: 2 }}
                  onClick={() => updateModal("noteBook", { state: true, item: params.row })}>edit</Icon>
            <Icon style={{ marginLeft: 2 }} onClick={() => {
              setCustomerPrintInfo(params.row);
              handleOpen();
            }}>print</Icon>
            {(me.role === "center" || me.role === "reservation") && <Icon color={"info"} style={{ marginLeft: 2 }}
                                                                          onClick={() => updateModal("noteBookHistory", {
                                                                            state: true,
                                                                            item: params.row,
                                                                          })}>history</Icon>}
            {params.row.status !== 1 && <Icon style={{ color: "red" }} onClick={() => {
              let answer = window.confirm("آیا از حذف بیمار اطمینان دارید؟");
              if (answer) {
                deleteNoteBook(params.row.id);
              } else {
              }
            }}>delete</Icon>}
            {isShowDeleteRequest ? <>
              <MDBadge onClick={() => handleUpdateNotebookStatus(params.row.id, 1)} badgeContent="تایید حذف"
                       color="success" size="lg" />
              <MDBadge onClick={() => handleUpdateNotebookStatus(params.row.id, 0)} badgeContent="رد حذف" color="error"
                       size="lg" />
            </> : <></>}
          </section>,
      },

    ]
  ;
  const [reservationNoteBook, setReservationNoteBook] = useState([]);
  const [loading, setLoading] = useState(false);
  const componentRef = React.useRef(null);
  const singlePatientRef = React.useRef(null);
  const [searchParam, setSearchParam] = useState(0);
  const [search, setSearch] = useState("");
  const [trigger, setTrigger] = useState(0);
  const [isShowDeleteRequest, setIsShowDeleteRequest] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const m = moment();

  const [selectedDay, setSelectedDay] = useState({
    from: null,
    to: null,
  });

  const renderCustomInput = ({ ref }) => (
      <input
        readOnly
        ref={ref}
        placeholder="بازه زمانی تاریخ"
        value={(selectedDay.from && selectedDay.to) ? `${selectedDay?.from?.year}/${selectedDay?.from?.month}/${selectedDay?.from?.day} - ${selectedDay?.to?.year}/${selectedDay?.to?.month}/${selectedDay?.to?.day}` : ""}
        style={{
          textAlign: "center",
          border: "1px solid #ccc",
          borderRadius: "0.375rem",
          color: "#495057",
          outline: "none",
          height: "44.3px",
          width: "150px",
          fontFamily: "IRANSansX",
        }}
      />
    )
  ;

  useEffect(() => {
    setLoading(true);
    let startDate = `${selectedDay?.from?.year}${String(selectedDay?.from?.month).padStart(2, "0")}${String(selectedDay?.from?.day).padStart(2, "0")}`;
    let endDate = `${selectedDay?.to?.year}${String(selectedDay?.to?.month).padStart(2, "0")}${String(selectedDay?.to?.day).padStart(2, "0")}`;

    let query = {
      from: (selectedDay?.to == null || selectedDay?.from == null) ? null : startDate,
      to: (selectedDay?.to == null || selectedDay?.from == null) ? null : endDate,
      page,
      status: isShowDeleteRequest ? 1 : null,
      pageSize: 25,
      fullname: searchParam === 0 ? search : null,
      nationalCode: searchParam === 1 ? search : null,
      phoneNumber: searchParam === 2 ? search : null,
    };

    getReservationNoteBook(queryString(query), (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        setTotalRow(data?.totalRowCount);
        return setReservationNoteBook(data.data);
      }
    });
  }, [page, trigger, isShowDeleteRequest]);

  const patientTablePrintContent = React.useCallback(() => {
    return singlePatientRef.current;
  }, [singlePatientRef.current]);
  const notebookTablePrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrintSinglePatient = useReactToPrint({
    content: patientTablePrintContent,
    onBeforePrint: () => setLoading(true),
    onAfterPrint: () => setLoading(false),
    removeAfterPrint: true,
  });
  const handlePrintNotebookReservation = useReactToPrint({
    content: notebookTablePrintContent,
    onBeforePrint: () => setLoading(true),
    onAfterPrint: () => setLoading(false),
    removeAfterPrint: true,
    pageStyle: "@page {size: A4 landscape;margin: 0;}",
  });

  const deleteNoteBook = (reservationNotebookId) => {
    setLoading(true);
    deleteReservationNoteBook(reservationNotebookId, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        toast.success(data.message);
        window.location.reload();
      }
    });
  };

  const handleUpdateNotebookStatus = (reservationNotebookId, isAccept) => {
    setLoading(true);
    const acceptData = {
      is_accept: 1,
    };
    const rejectData = {
      is_reject: 1,
    };
    updateReservationNoteBookStatus(reservationNotebookId, isAccept ? acceptData : rejectData, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        toast.success(data.message);
        window.location.reload();
      }
    });
  };
  const rows = reservationNoteBook.map((item, index) => ({ index: index + 1, ...item, operation: "operation" }));
  return (
    <DashboardLayout>
      <Loading loading={loading} />
      <MDBox pt={2} mb={6}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <MDTypography variant="h6" color="white">
                  جزئیات دفتر نوبت دهی
                </MDTypography>
                <DashboardNavbar />
              </MDBox>
              <MDBox pt={6} px={2}>
                <div style={{ marginBottom: 8, display: "flex", alignItems: "center" }}>
                  <MDButton
                    onClick={handlePrintNotebookReservation}
                    variant="gradient" color="info"
                    sx={{ width: "140px", marginRight: 2 }}>
                    دریافت گزارش
                  </MDButton>
                  <DatePicker
                    value={selectedDay}
                    onChange={setSelectedDay}
                    renderInput={renderCustomInput}
                    selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
                    selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
                    shouldHighlightWeekends
                    locale="fa"
                    colorPrimary="#0fbcf9"
                    colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                  />
                  <FormControl sx={{ width: "150px", margin: "0 0.5rem" }}>
                    <InputLabel>پارامتر جستجو</InputLabel>
                    <Select value={searchParam}
                            onChange={(event) => setSearchParam(event.target.value)}
                            label="پارامتر جستجو" sx={{ height: "44.3px" }}>
                      <MenuItem value={0}>نام و نام خانوادگی</MenuItem>
                      <MenuItem value={1}>کد ملی</MenuItem>
                      <MenuItem value={2}>شماره موبایل</MenuItem>
                    </Select>
                  </FormControl>
                  <MDInput value={search} onChange={(event) => setSearch(event.target.value)}
                           type="text"
                           label="جستجو" sx={{ width: "150px" }} />
                  <MDButton onClick={() => setTrigger(Math.random())} variant="gradient"
                            color="success"
                            sx={{ marginLeft: 2 }}>
                    جستجو
                  </MDButton>
                  {(me.role === "center" || me.role === "reservation") &&
                    <section style={{ display: "flex", alignItems: "center", marginRight: 10 }}>
                      <input id="checkbox" value={isShowDeleteRequest}
                             onChange={(event) => setIsShowDeleteRequest(event.target.checked)} type="checkbox"
                             style={{
                               width: "1rem",
                               height: "1rem",
                               backgroundColor: "#f3f4f6",
                               color: "#009dfe",
                               borderRadius: "0.25rem",
                               border: "1px solid rgb(209 213 219)",
                             }} />
                      <label htmlFor="checkbox" style={{
                        marginLeft: "8rem",
                        fontSize: "13px",
                        paddingRight: "0.5rem",
                        display: "flex",
                      }}>درخواست های حذف</label>
                    </section>}
                </div>
                <div id="scrollableDiv">
                  <DataGrid
                    rows={rows}
                    ref={componentRef}
                    columns={columns}
                    pageSizeOptions={[25]}
                    getRowId={(item) => item.id}
                    rowSelection={false}
                    paginationModel={{ page, pageSize: 25 }}
                    onPaginationModelChange={(model) => setPage(model.page)}
                    rowCount={totalRow}
                    paginationMode="server"
                  />
                </div>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Modal open={open} onClose={handleClose}>
        <MDBox sx={style}>
          <div ref={singlePatientRef} style={{ margin: "1rem", fontSize: 14 }}>
            <p>نام بیمار: {customerPrintInfo?.fullname}</p>
            <p>شماره موبایل: {customerPrintInfo.phoneNumber}</p>
            <p>تاریخ
              نوبت: {`${String(customerPrintInfo.reservationDate).slice(0, 4)}/${String(customerPrintInfo.reservationDate).slice(4, 6)}/${String(customerPrintInfo.reservationDate).slice(6)}`}</p>
            <p>ساعت نوبت: {customerPrintInfo.subTime}</p>
            <p>تخصص نوبت: {`${customerPrintInfo.nameGroup} - ${customerPrintInfo.subNameGroup}`}</p>
            <p>کدملی: {customerPrintInfo.nationalCode}</p>
          </div>
          <MDButton onClick={handlePrintSinglePatient} variant="gradient" color="info"
                    sx={{ width: "140px", marginRight: 4 }}>
            چاپ
          </MDButton>
        </MDBox>
      </Modal>
      {modals.noteBook.state &&
        <UpdateReservationNoteBookModal modal={modals.noteBook} handleClose={() => closeModal("noteBook")} />}
      {modals.noteBookHistory.state &&
        <ReservationNoteBookHistoryModal modal={modals.noteBookHistory}
                                         handleClose={() => closeModal("noteBookHistory")} />}
    </DashboardLayout>
  );
}
